// Wishlist Cart Badge Settings (from Shopify Customizer)
window.__sylviWishlistBadge = {
  position: "image"
};

// Footer Links Start
function toggleFooterLinks() {
  const footerOuterCont = document.querySelector('.footer_outer_cont');
  const footerLinkDiv = document.querySelector('.footer_link_div');
  footerOuterCont.addEventListener('click', function() {
    if (footerLinkDiv.classList.contains('expand')) {
      // Collapse the div
      footerLinkDiv.style.maxHeight = '0px';
      footerLinkDiv.classList.remove('expand');
    } else {
      // Expand the div - set max-height dynamically based on scrollHeight
      footerLinkDiv.style.maxHeight = footerLinkDiv.scrollHeight + 'px';
      footerLinkDiv.classList.add('expand');
    }
  });
}
document.addEventListener('DOMContentLoaded', toggleFooterLinks);
// Footer Links End
// Footer General FAQs Start
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq");
  faqItems.forEach(function (item) {
    const question = item.querySelector(".question");
    const answer = item.querySelector(".answer");
    question.addEventListener("click", function () {
      faqItems.forEach(function (faqItem) {
        if (faqItem !== item) {
          faqItem.querySelector(".answer").style.display = "none";
          faqItem.querySelector(".question").classList.remove("open");
        }
      });
      if (answer.style.display === "block") {
        answer.style.display = "none";
        question.classList.remove("open");
      } else {
        answer.style.display = "block";
        question.classList.add("open");
      }
    });
  });  
});
// Footer General FAQs End
// Product Specification Start
document.addEventListener("DOMContentLoaded", function () {
  const helpTooltips = document.querySelectorAll(".spec_ul li");
  helpTooltips.forEach(function (tooltip) {
    const tooltipText = tooltip.getAttribute("data-tooltip");
    const tooltipBox = document.createElement("div");
    tooltipBox.classList.add("tooltip-box");
    tooltipBox.textContent = tooltipText;
    tooltip.appendChild(tooltipBox);
  });
});
// Product Specification End
// Prototype T&C Start
$(document).ready(function () {
  $("#tnc_link").on("click", function (event) {
    event.preventDefault();
    var targetId = "tnc";
    var additionalScroll = 100;
    var targetPosition = $("#" + targetId).offset().top - additionalScroll;
    $("html, body").animate({
      scrollTop: targetPosition
    }, 1000);
  });
});
function toggleTnc() {
  var outerCont = document.getElementById("TncOuterDiv");
  outerCont.classList.toggle("active");
  var linkDiv = document.getElementById("TncInnerDiv");
  var style = window.getComputedStyle(linkDiv);
  if (style.display === "block") {
    linkDiv.style.opacity = "0";
    setTimeout(function () {
      linkDiv.style.display = "none";
    }, 500);
  } else {
    linkDiv.style.display = "block";
    setTimeout(function () {
      linkDiv.style.opacity = "1";
    }, 50);
  }
}
// Prototype T&C End 
// Automatic Filename as ALT tag Start
function updateAltAttribute() {
    var images = document.getElementsByTagName('img');
    for (var i = 0; i < images.length; i++) {
        var image = images[i];
        var src=image.src;
        var filename = src.split('/').pop().split('#')[0].split('?')[0];
      // if (image.alt == blank){
      //   image.alt = filename;
      // }
    }
}
document.addEventListener("DOMContentLoaded", updateAltAttribute);
// Automatic Filename as ALT tag End
function check_alt(color_image, data_id) {
  if (!color_image) return;
  $('.product__thumb-item').hide();
  $('.product__thumb-item img').each(function(){
    var alt_val = $(this).attr('alt') || '';
    if(alt_val.indexOf(color_image) !== -1){
      $(this).parents('.product__thumb-item').css('display', 'inline-block');
    }  
  });
  var firstThumbAlt = $('.product__thumb-item img').attr('alt') || '';
  if(firstThumbAlt.indexOf(color_image) !== -1){
    $('img[alt="'+color_image+'"]').parents('.product__thumb-item').css('display', 'inline-block');
  }  
  var visibleElementsCount = $('.product__thumb-item:visible').length;  
  if (visibleElementsCount > 8) {
    $('.product__thumb-arrow').show();
    $('.product__thumbs--scroller').addClass('add_padding');
  }
  if (data_id) {
    $('#'+data_id).show().siblings().hide();
    $('.product_specification .custom-content[data-element="'+data_id+'"]').css('display', 'flex').siblings().hide();
  }
}
$(document).on('click', '.variant-input', function(){
  var color_image = $(this).attr('data-value'),
    data_id = $(this).attr('data-id');
  if (color_image) {
    check_alt(color_image, data_id);
  }
});
$(window).on('load', function(){
  if ($('.variant__input--color-swatch:checked').length) {
    var color_image = $('.variant__input--color-swatch:checked').parents('.variant-input').attr('data-value'),
      data_id = $('.variant__input--color-swatch:checked').parents('.variant-input').attr('data-id');
    if (color_image) {
      check_alt(color_image, data_id);
    }
  }
});
$(".product-image-main").on('click touchstart', function() {
  var alt_img = $(this).parents('.product-main-slide').next().find('img').attr('alt');
  if (alt_img) {
    $('.variant-input').each( function() {      
      var var_val = $(this).find('input').val();
      if (var_val && alt_img.indexOf(var_val) != -1) {
        $(this).find('input').trigger('click');
      }
    });
  }
});
/* variation sold out product start */
document.querySelectorAll('.prod_var_cont').forEach(function(container) {
  const moreButton = container.querySelector('.open-drawer-btn');
  Array.prototype.slice.call(container.children).forEach(function(item) {
    if (item.classList.contains('sold') && !item.classList.contains('hidden')) {
      if (moreButton) {
        container.insertBefore(item, moreButton);
      } else {
        container.appendChild(item);
      }
    }
  });
});
/* variation sold out product end */
/* ── SYLVI UIUX (2026-06-12): Judge.me sticky-header scroll fix ─────────────────
   On pagination Judge.me swaps the review list IN PLACE (no scrollTo — traced), so the new page's top
   reviews sit under the fixed header (.site-header--stuck, ~100px). Same on "Write a review" (form opens
   in place). Fix: on those clicks, actively scroll the widget header / form to sit just below the header. */
(function () {
  function headerEl() { return document.querySelector('.site-header--stuck') || document.querySelector('.site-header'); }
  function headerOffset() {
    var h = headerEl(); if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return 0;
    return Math.round(h.getBoundingClientRect().height) + 16;
  }
  function correctTarget(getEl) {
    var off = headerOffset();
    if (off <= 0) return;
    var tries = 0;
    (function tick() {
      tries++;
      var el = getEl();
      if (el) {
        var top = el.getBoundingClientRect().top;
        if (top > -40 && top < off) {
          window.scrollBy({ top: top - off, behavior: 'auto' });
        }
      }
      if (tries < 22) setTimeout(tick, 90);
    })();
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.jdgm-paginate')) {
      correctTarget(function () { return document.querySelector('.jdgm-rev-widg__reviews'); });
    } else if (t.closest('.jdgm-write-rev-link')) {
      correctTarget(function () {
        var f = document.querySelector('.jdgm-form');
        return (f && f.getBoundingClientRect().height > 50) ? f : null;
      });
    }
  }, true);
})();
/* ── SYLVI UIUX (2026-06-12): Judge.me long-review "View more" cards ──────────
   Judge.me replaces review DOM on sort/pagination, so enhance the rendered cards and watch for swaps. */
(function () {
  if (window.SylviJudgeMeReadMore) return;
  window.SylviJudgeMeReadMore = true;
  var REVIEW_SELECTOR = '.jdgm-rev-widg__reviews .jdgm-rev';
  var TOGGLE_CLASS = 'jdgm-review-toggle';
  var LONG_REVIEW_LENGTH = 220;
  var scheduled = null;
  function needsToggle(review, body) {
    var text = (body.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > LONG_REVIEW_LENGTH) return true;
    var wasExpanded = review.classList.contains('is-expanded');
    var collapsedHeight = body.getBoundingClientRect().height;
    review.classList.add('is-expanded');
    var expandedHeight = body.getBoundingClientRect().height;
    if (!wasExpanded) review.classList.remove('is-expanded');
    return expandedHeight > collapsedHeight + 4;
  }
  function enhanceReview(review) {
    if (!review || review.getAttribute('data-sylvi-readmore') === 'true') return;
    var body = review.querySelector('.jdgm-rev__body');
    if (!body) return;
    review.setAttribute('data-sylvi-readmore', 'true');
    review.classList.remove('is-expanded');
    requestAnimationFrame(function () {
      if (!document.documentElement.contains(review)) return;
      if (!needsToggle(review, body)) {
        review.classList.add('jdgm-rev--no-toggle');
        return;
      }
      review.classList.add('jdgm-rev--has-toggle');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = TOGGLE_CLASS;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'View more';
      body.insertAdjacentElement('afterend', button);
    });
  }
  function enhanceReviews(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(REVIEW_SELECTOR).forEach(enhanceReview);
  }
  function scheduleEnhance() {
    clearTimeout(scheduled);
    scheduled = setTimeout(function () { enhanceReviews(document); }, 120);
  }
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('.' + TOGGLE_CLASS) : null;
    if (!button) return;
    var review = button.closest('.jdgm-rev');
    if (!review) return;
    var expanded = review.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? 'View less' : 'View more';
  });
  function initReviewToggles() {
    enhanceReviews(document);
    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('.jdgm-rev, .jdgm-rev-widg__reviews')) ||
            (node.querySelector && node.querySelector('.jdgm-rev'))
          ) {
            scheduleEnhance();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewToggles);
  } else {
    initReviewToggles();
  }
})();
/* ── Skeleton shimmer: stop when image actually renders (2026-06-15) ─────────
   lazysizes adds 'lazyloaded' when it sets srcset, BEFORE the CDN fetch
   completes. We add .image-fetching (hides broken-icon) at that moment and
   remove it when the image actually loads. Works on all browsers. */
(function () {
  function markLoaded(img) {
    img.classList.remove('image-fetching');
    img.classList.add('image-ready');
    var wrap = img.closest && img.closest('.image-wrap');
    if (wrap) wrap.classList.add('image-wrap--loaded');
  }
  function markError(img) {
    img.classList.remove('image-fetching');
    var wrap = img.closest && img.closest('.image-wrap');
    if (wrap) wrap.classList.add('image-wrap--error');
  }
  document.addEventListener('lazyloaded', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    var wrap = img.closest && img.closest('.image-wrap');
    if (!wrap) return;
    if (img.complete && img.naturalWidth > 0) { markLoaded(img); return; }
    if (img.complete && img.naturalWidth === 0) { markError(img); return; }
    img.classList.add('image-fetching');
    img.addEventListener('load',  function () { markLoaded(img); }, { once: true });
    img.addEventListener('error', function () { markError(img);  }, { once: true });
  });
  function checkExistingImages() {
    var imgs = document.querySelectorAll('.image-wrap img.lazyloaded');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth > 0) { markLoaded(img); }
        else if (img.complete) { markError(img); }
        else {
          img.addEventListener('load',  function () { markLoaded(img); }, { once: true });
          img.addEventListener('error', function () { markError(img);  }, { once: true });
        }
      })(imgs[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkExistingImages);
  } else {
    checkExistingImages();
  }
})();
/* =========================================================================
   Wishlist Plus Floating Button Integration (Added by Antigravity - 06 AUG 2026)
   FIXED (2026-08-07):
   1. getCurrentVariantId/getCurrentProductId now read the real Wishlist Plus
      attributes (data-varid / data-proid) instead of nonexistent
      data-variant-id / data-empi.
   2. Added syncFromAppButton() so the floating button's data-added state is
      pulled from the native wl-btn's data-added attribute on every
      updateState() call.
   3. Fixed header badge count going wrong (e.g. 5 -> 1) after clicking the
      floating button. Previously the badge was set from
      window.__wishlistCache.length, but that cache is hydrated
      asynchronously (from localStorage + Swym fetch) and is often not fully
      populated yet at click time, so a single push/splice made length look
      like 1 instead of the real total. Now we read the badge's CURRENTLY
      DISPLAYED number and apply a +1/-1 delta instead of trusting cache
      length, so a partially-hydrated cache can never clobber the real count.
   4. Added getAppWishlistBtn(): document.querySelector(SELECTORS.appWishlistBtn)
      was returning the FIRST DOM match across all combined selectors, which
      on the PDP is often the outer wrapper <div id="...wishlist_btn...">
      (its id contains "wishlist_btn") rather than the inner <a class="wl-btn"
      data-added data-varid data-proid ...>. That wrapper div has none of the
      real data attributes, so every lookup silently failed and the floating
      heart never picked up the correct wishlisted state on the PDP even
      though the wishlist page showed the product was saved. Now we
      specifically look for an element carrying [data-varid][data-added] (or
      [data-epi][data-added]) first, falling back to the old combined
      selector only if that isn't found.
   ========================================================================= */
(function() {
  var SELECTORS = {
    imageContainers: [
      '.product__photos', 
      '.product__main-photos', 
      '.product-single__media-group',
      '.product-single__photos', 
      '.product__media-container',
      '.grid-product__image-mask', 
      '.product-slideshow'
    ],
    appWishlistBtn: '.wl-btn-heart-wl-animation, .wl-btn, .btn-wishlist, #wishlist-btn, [class*="wishlist_btn"], [id*="wishlist_btn"], [class*="wishlist-btn"], [id*="wishlist-btn"]',
    headerBadges: [
      '.wl-header-count',
      '.header__wishlist-count',
      '.wishlist-count',
      '#wishlist-badge',
      '.wl-icon-text',
      '.wl-header-icon-link .wl-header-count',
      '[data-wl-count]'
    ]
  };

  // FIXED: find the element that actually CARRIES the data attributes,
  // not just the first DOM match against the broad combined selector
  // (which can land on a wrapping div with a matching id/class substring).
  function getAppWishlistBtn() {
    var withData = document.querySelector('[data-varid][data-added], [data-epi][data-added]');
    if (withData) return withData;
    return document.querySelector(SELECTORS.appWishlistBtn);
  }

  function initFloatingWishlist() {
    // Only run if custom wishlist is enabled in theme customize settings
    if (window.showCustomWishlist !== true) {
      document.body.classList.remove('custom-wishlist-active');
      var existingBtn = document.getElementById('custom-floating-wishlist');
      if (existingBtn && existingBtn.parentNode) existingBtn.parentNode.removeChild(existingBtn);
      return;
    }
    document.body.classList.add('custom-wishlist-active');
    var container = null;
    for (var i = 0; i < SELECTORS.imageContainers.length; i++) {
      var selector = SELECTORS.imageContainers[i];
      var el = document.querySelector(selector);
      if (el && el.offsetHeight > 50) { 
        container = el;
        break;
      }
    }
    if (!container) {
      setTimeout(initFloatingWishlist, 1000);
      return;
    }
    if (document.getElementById('custom-floating-wishlist')) return;
    var floatBtn = document.createElement('button');
    floatBtn.id = 'custom-floating-wishlist';
    floatBtn.className = 'custom-wishlist-floating-btn wl-coll-btn';
    floatBtn.setAttribute('aria-label', 'Add to Wishlist');
    floatBtn.setAttribute('data-added', 'false');
    floatBtn.innerHTML = '<div style="display: initial;"><span class="wl-coll-heart"><svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" fill="none" stroke-width="2"></path></svg></span></div>';
    
    var style = window.getComputedStyle(container);
    if (style.position === 'static') {
      container.style.position = 'relative';
    }
    container.appendChild(floatBtn);

    // Pull the native Wishlist Plus button's data-added state into the
    // shared __wishlistCache so isCurrentProductWishlisted() reflects reality.
    function syncFromAppButton() {
      var appBtn = getAppWishlistBtn();
      if (!appBtn) return;
      var vid = appBtn.getAttribute('data-varid') ||
                appBtn.getAttribute('data-variant-id') ||
                appBtn.getAttribute('data-epi') ||
                appBtn.getAttribute('data-id');
      if (!vid) return;
      vid = String(vid);
      var isAdded = appBtn.getAttribute('data-added') === 'true';
      window.__wishlistCache = window.__wishlistCache || [];
      var idx = window.__wishlistCache.indexOf(vid);
      if (isAdded && idx === -1) {
        window.__wishlistCache.push(vid);
      } else if (!isAdded && idx !== -1) {
        window.__wishlistCache.splice(idx, 1);
      }
    }

    // Read whatever number is CURRENTLY shown on the header badge (source of
    // truth at any given moment) rather than trusting cache length, which
    // may not be fully hydrated yet.
    function getDisplayedBadgeCount() {
      var badgeEl = document.querySelector(SELECTORS.headerBadges.join(','));
      if (!badgeEl) return NaN;
      var n = parseInt((badgeEl.textContent || '').replace(/[^\d]/g, ''), 10);
      return isNaN(n) ? NaN : n;
    }

    function updateState() {
      syncFromAppButton();
      var variantId = getCurrentVariantId();
      var isAdded = isCurrentProductWishlisted();
      
      floatBtn.setAttribute('data-added', isAdded ? 'true' : 'false');
      
      var path = floatBtn.querySelector('svg path');
      if (path) {
          if (isAdded) {
              floatBtn.classList.add('added');
              path.setAttribute('fill', 'currentColor');
              path.setAttribute('stroke', 'none');
          } else {
              floatBtn.classList.remove('added');
              path.setAttribute('fill', 'none');
              path.setAttribute('stroke', 'currentColor');
              path.setAttribute('stroke-width', '2');
          }
      }
    }
    floatBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var variantId = getCurrentVariantId();
      var productId = getCurrentProductId();
      if (variantId && productId) {
          variantId = String(variantId);
          productId = Number(productId);
          
          window.__wishlistCache = window.__wishlistCache || [];
          var idx = window.__wishlistCache.indexOf(variantId);
          var isRemoving = (idx !== -1);
          
          // 1. Update local cache immediately for instant UI response
          if (isRemoving) {
              window.__wishlistCache.splice(idx, 1);
              console.log('[CustomFloatingWL] Local remove. Cache:', window.__wishlistCache);
          } else {
              window.__wishlistCache.push(variantId);
              console.log('[CustomFloatingWL] Local add. Cache:', window.__wishlistCache);
          }
          
          // 2. Update UI components
          // Use a delta against the badge's currently displayed number instead
          // of window.__wishlistCache.length, which may only be partially
          // hydrated at click time and would wrongly overwrite a correct
          // larger count (e.g. 5) with a small one (e.g. 1).
          (function updateBadgeByDelta() {
              var currentCount = getDisplayedBadgeCount();
              if (isNaN(currentCount)) {
                  // No existing badge value to read from — fall back to cache length only now
                  currentCount = window.__wishlistCache.length + (isRemoving ? 1 : -1);
                  if (currentCount < 0) currentCount = 0;
              }
              var newCount = isRemoving ? Math.max(0, currentCount - 1) : currentCount + 1;
              if (typeof window.updateAllHeaderWishlistBadges === 'function') {
                  window.updateAllHeaderWishlistBadges(newCount);
              }
          })();
          updateState();
          // 3. Sync with Swym database
          var productDetails = {
              epi: Number(variantId),
              empi: productId,
              du: window.location.origin + window.location.pathname
          };
          if (window._swat && typeof window._swat.addToWishList === 'function') {
              if (isRemoving) {
                  window._swat.removeFromWishList(productDetails, function() {
                      console.log('[CustomFloatingWL] Swym API remove success');
                      if (typeof window.dispatchWishlistUpdate === 'function') {
                          window.dispatchWishlistUpdate();
                      }
                  });
              } else {
                  window._swat.addToWishList(productDetails, function() {
                      console.log('[CustomFloatingWL] Swym API add success');
                      if (typeof window.dispatchWishlistUpdate === 'function') {
                          window.dispatchWishlistUpdate();
                      }
                  });
              }
          } else {
              // Fallback to native button click if _swat is not ready
              var appBtn = getAppWishlistBtn();
              if (appBtn) appBtn.click();
          }
          floatBtn.classList.add('pop');
          setTimeout(function() { floatBtn.classList.remove('pop'); }, 400);
      }
    });
    observeAppButtonState(floatBtn, updateState);
  }
  function getCurrentVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariantId = urlParams.get('variant');
    if (urlVariantId) return urlVariantId;
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    var appBtn = getAppWishlistBtn();
    if (appBtn) {
        var vid = appBtn.getAttribute('data-varid') ||
                  appBtn.getAttribute('data-variant-id') ||
                  appBtn.getAttribute('data-epi') ||
                  appBtn.getAttribute('data-id');
        if (vid) return String(vid);
    }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
        return String(window.ShopifyAnalytics.meta.selectedVariantId);
    }
    if (window.meta && window.meta.selectedVariantId) {
        return String(window.meta.selectedVariantId);
    }
    return null;
  }
  function getCurrentProductId() {
    var appBtn = getAppWishlistBtn();
    if (appBtn) {
        var pid = appBtn.getAttribute('data-proid') ||
                  appBtn.getAttribute('data-product-id') ||
                  appBtn.getAttribute('data-empi') ||
                  appBtn.getAttribute('data-id');
        if (pid) return Number(pid);
    }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) {
        return Number(window.ShopifyAnalytics.meta.product.id);
    }
    if (window.meta && window.meta.product && window.meta.product.id) {
        return Number(window.meta.product.id);
    }
    if (window.meta && window.meta.productId) {
        return Number(window.meta.productId);
    }
    var pidInput = document.querySelector('form[action*="/cart/add"] input[name="product-id"], [data-product-id]');
    if (pidInput) {
        var val = pidInput.value || pidInput.getAttribute('data-product-id');
        if (val) return Number(val);
    }
    return null;
  }
  function isCurrentProductWishlisted() {
    var vid = getCurrentVariantId();
    if (vid && window.__wishlistCache && window.__wishlistCache.indexOf(String(vid)) !== -1) {
        return true;
    }
    try {
        var productMeta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || window.meta;
        if (productMeta && productMeta.variants && Array.isArray(productMeta.variants)) {
            return productMeta.variants.some(function(v) {
                return window.__wishlistCache && window.__wishlistCache.indexOf(String(v.id)) !== -1;
            });
        }
    } catch(e) {}
    return false;
  }
  function observeAppButtonState(floatBtn, updateState) {
    updateState();
    // Listen to cache synchronization events
    document.addEventListener('wishlistPlus:added', updateState);
    document.addEventListener('wishlist:updated', updateState);
    document.addEventListener('click', function() {
        setTimeout(updateState, 500);
    });
    var observer = new MutationObserver(updateState);
    
    var searchInterval = setInterval(function() {
      var appBtn = getAppWishlistBtn();
      if (appBtn) {
        clearInterval(searchInterval);
        observer.observe(appBtn, { 
          attributes: true, 
          childList: true, 
          subtree: true, 
          attributeFilter: ['class', 'data-added', 'style'] 
        });
        updateState();
      }
    }, 500);
    setInterval(updateState, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingWishlist);
  } else {
    initFloatingWishlist();
  }
  // Support Shopify Customizer live updates
  document.addEventListener('shopify:section:load', function(e) {
    initFloatingWishlist();
  });
})();

/* =========================================================================
   Global Wishlist -> Cart Interceptor
   Ensures _is_wishlist: true is passed for all Add to Cart flows
   Added by Antigravity
   ========================================================================= */
(function() {
    if (window.__sylviWishlistCartInterceptorInstalled) return;
    window.__sylviWishlistCartInterceptorInstalled = true;

    // Proactively hydrate cache from Swym to ensure global state is correct
    function hydrateCacheFromSwym() {
        if (window._swat && typeof window._swat.fetch === 'function') {
            window._swat.fetch(function(products) {
                if (!Array.isArray(products)) return;
                window.__wishlistCache = window.__wishlistCache || [];
                products.forEach(function(p) {
                    var vid = String(p.epi || p.variantId || p.variant_id || p.id);
                    if (vid && window.__wishlistCache.indexOf(vid) === -1) {
                        window.__wishlistCache.push(vid);
                    }
                });
            });
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            hydrateCacheFromSwym();
            setTimeout(hydrateCacheFromSwym, 1000);
        });
    } else {
        hydrateCacheFromSwym();
        setTimeout(hydrateCacheFromSwym, 1000);
    }
    
    // =========================================================================
    // Smart Cart Consolidator Engine
    // Automatically aligns line item properties in the background when the wishlist changes
    // =========================================================================
    function syncCartWishlistProperty(variantId, isAddingToWishlist) {
        if (!variantId) return;
        
        var _fetch = window._nativeFetch || window.fetch;
        _fetch('/cart.js').then(function(res) { return res.json(); }).then(function(cart) {
            if (!cart || !cart.items) return;
            
            var itemToUpdate = null;
            var lineIndex = -1;
            
            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                if (String(item.variant_id) === String(variantId) || String(item.product_id) === String(variantId)) {
                    var hasProperty = item.properties && item.properties._is_wishlist === 'true';
                    if (isAddingToWishlist && !hasProperty) {
                        itemToUpdate = item;
                        lineIndex = i + 1;
                        break;
                    }
                    if (!isAddingToWishlist && hasProperty) {
                        itemToUpdate = item;
                        lineIndex = i + 1;
                        break;
                    }
                }
            }
            
            if (itemToUpdate && lineIndex !== -1) {
                var newProps = Object.assign({}, itemToUpdate.properties || {});
                if (isAddingToWishlist) {
                    newProps._is_wishlist = 'true';
                } else {
                    delete newProps._is_wishlist; // Remove property
                }
                
                _fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: lineIndex,
                        quantity: itemToUpdate.quantity,
                        properties: newProps
                    })
                }).catch(function(e) {
                    console.error('SYLVI Consolidator Error:', e);
                });
            }
        }).catch(function(e){});
    }

    // Listen to Swym wishlist events
    document.addEventListener('wishlistPlus:added', hydrateCacheFromSwym);
    document.addEventListener('wishlist:updated', hydrateCacheFromSwym);
    document.addEventListener('click', function(e) {
        var btn = e.target && typeof e.target.closest === 'function' ? e.target.closest('.swym-button, .swym-wishlist-item, .wl-add-to-cart-btn, .wl-coll-btn') : null;
        if (btn) {
            setTimeout(hydrateCacheFromSwym, 300);
            setTimeout(hydrateCacheFromSwym, 1000);
            
            // Trigger Smart Cart Consolidator
            var variantId = btn.getAttribute('data-variant-id') || btn.getAttribute('data-varid') || btn.getAttribute('data-product-id');
            if (variantId) {
                setTimeout(function() {
                    var isWishlisted = window.isSylviVariantWishlisted(variantId);
                    syncCartWishlistProperty(variantId, isWishlisted);
                }, 700); // Wait 700ms for Swym to register the click internally
            }
        }
    });

    // Safe URL checker
    function isShopifyCartAddUrl(input) {
        try {
            var rawUrl = input instanceof Request ? input.url : String(input);
            if (rawUrl.indexOf('/cart/add') === -1) return false;
            
            var base = document.baseURI || window.location.origin;
            var parsed = new URL(rawUrl, base);

            if (parsed.origin !== window.location.origin) return false;

            var path = parsed.pathname.replace(/\/+$/, '');
            return (path === '/cart/add' || path === '/cart/add.js' || path === '/cart/add.json');
        } catch (e) {
            return false;
        }
    }

    // Safe Wishlist check helper
    window.isSylviVariantWishlisted = function (variantId) {
        if (variantId === undefined || variantId === null || variantId === '') return false;
        
        // Fast Path: Wishlist page
        if (window.location.pathname.indexOf('/apps/wishlist') !== -1) {
            return true;
        }
        
        var cache = window.__wishlistCache;
        if (Array.isArray(cache) && cache.indexOf(String(variantId)) !== -1) {
            return true;
        }
        
        // Fallback: Check if Swym has rendered an active heart button on the grid for this variant
        try {
            var domBtn = document.querySelector('.swym-added[data-variant-id="' + variantId + '"], .swym-added[data-epi="' + variantId + '"], .wl-active[data-varid="' + variantId + '"], [data-added="true"][data-varid="' + variantId + '"]');
            if (domBtn) {
                window.__wishlistCache = window.__wishlistCache || [];
                window.__wishlistCache.push(String(variantId));
                return true;
            }
            
            // Fallback for collection pages where Swym buttons might only have data-product-id
            var forms = document.querySelectorAll('form[action*="/cart/add"]');
            for (var i = 0; i < forms.length; i++) {
                var form = forms[i];
                var idField = form.querySelector('[name="id"]');
                if (idField && String(idField.value) === String(variantId)) {
                    var card = form.closest('.grid-product, .grid-item, .product-tile-wrapper, .product-item, .card-wrapper') || form;
                    if (card.querySelector('.swym-added')) {
                        window.__wishlistCache = window.__wishlistCache || [];
                        window.__wishlistCache.push(String(variantId));
                        return true;
                    }
                }
            }
        } catch(e) {}
        
        return false;
    };

    // Helper to merge _is_wishlist into properties and enforce string type for cart merging
    function applyWishlistProperty(item) {
        if (item && item.properties && item.properties._is_wishlist === true) {
            // Force Swym's native boolean true to string "true" so it merges with FormData additions
            item.properties._is_wishlist = 'true';
        }
        if (item && item.id && window.isSylviVariantWishlisted(item.id)) {
            item.properties = item.properties || {};
            item.properties._is_wishlist = 'true';
        }
        return item;
    }

    // Helper to process JSON bodies safely
    function processJsonBody(bodyString) {
        try {
            var data = JSON.parse(bodyString);
            if (data.items && Array.isArray(data.items)) {
                data.items = data.items.map(applyWishlistProperty);
                return JSON.stringify(data);
            } else if (data.id) {
                data = applyWishlistProperty(data);
                return JSON.stringify(data);
            }
        } catch (e) {
            console.error('SYLVI Interceptor JSON parse error:', e);
        }
        return bodyString; // fallback
    }

    // Helper to process FormData safely
    function processFormData(formData) {
        try {
            var id = formData.get('id');
            if (id && window.isSylviVariantWishlisted(id)) {
                if (!formData.has('properties[_is_wishlist]')) {
                    formData.append('properties[_is_wishlist]', 'true');
                }
            }
        } catch (e) {
            console.error('SYLVI Interceptor FormData parse error:', e);
        }
        return formData;
    }
    
    // Helper to process URLSearchParams / urlencoded body safely
    function processUrlEncoded(bodyString) {
        try {
            var params = new URLSearchParams(bodyString);
            var id = params.get('id');
            if (id && window.isSylviVariantWishlisted(id)) {
                if (!params.has('properties[_is_wishlist]')) {
                    params.append('properties[_is_wishlist]', 'true');
                    return params.toString();
                }
            }
        } catch(e) {
            console.error('SYLVI Interceptor URLSearchParams parse error:', e);
        }
        return bodyString;
    }

    // Intercept Fetch
    var _nativeFetch = window.fetch;
    window.fetch = function(input, init) {
        if (!isShopifyCartAddUrl(input)) {
            return _nativeFetch.apply(this, arguments);
        }

        try {
            // If the input is a complex Request object, modifying it is risky. 
            // Fall back to original for safety to prevent consuming the body.
            if (input instanceof Request) {
                return _nativeFetch.apply(this, arguments);
            }

            var opts = init || {};
            if (opts.body) {
                if (typeof opts.body === 'string') {
                    if (opts.body.trim().startsWith('{')) {
                        opts.body = processJsonBody(opts.body);
                    } else if (opts.body.includes('id=')) {
                        opts.body = processUrlEncoded(opts.body);
                    }
                } else if (opts.body instanceof FormData) {
                    opts.body = processFormData(opts.body);
                }
            }
            return _nativeFetch.call(this, input, opts);
        } catch (e) {
            console.error('SYLVI Fetch Intercept Error:', e);
            return _nativeFetch.apply(this, arguments);
        }
    };

    // Intercept XHR
    var _nativeXHRopen = XMLHttpRequest.prototype.open;
    var _nativeXHRsend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
        this.__sylviCartAddUrl = isShopifyCartAddUrl(url);
        return _nativeXHRopen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
        try {
            if (this.__sylviCartAddUrl && body) {
                if (typeof body === 'string') {
                    if (body.trim().startsWith('{')) {
                        body = processJsonBody(body);
                    } else if (body.includes('id=')) {
                        body = processUrlEncoded(body);
                    }
                } else if (body instanceof FormData) {
                    body = processFormData(body);
                }
            }
        } catch(e) {
            console.error('SYLVI XHR Intercept Error:', e);
        }
        return _nativeXHRsend.apply(this, arguments);
    };

})();